import React, { FC } from 'react';

import BarPointsForm from 'components/BarPointsForm/BarPointsForm';
import RichText from 'components/RichText/RichText';

interface IProgressBarValues {
  progressBarId: string | null;
  progressBarPoints: number | null;
}

interface IOfferProgressBarSectionProps {
  initialValues: {
    progressBarId?: string | null;
    progressBarPoints?: number | null;
  };
  onChange: (
    values: IProgressBarValues,
    isValid: boolean,
    isDirty: boolean
  ) => void;
  description?: string;
  className?: string;
}

const OfferProgressBarSection: FC<IOfferProgressBarSectionProps> = ({
  initialValues,
  onChange,
  description = 'Track and update progress for your products',
  className
}): React.ReactElement => {
  return (
    <div className={className}>
      <RichText
        title="Progress Bar"
        description={description}
        className="mb-5"
      />
      <BarPointsForm initialValues={initialValues} onChange={onChange} />
    </div>
  );
};

export { OfferProgressBarSection };
